
// import React, { useState, useEffect } from "react";
// import "./CampaignList.css";
// import { fetchCampaigns, updateCampaign } from "../services/campaignService";
// import { fetchBrands } from "../services/brandService";

// const campaignTypeNames = {
//   1: "Visibility Audit",
//   2: "Retail Audit",
//   3: "Sampling",
// };

// function CampaignList({ onCreateClick }) {
//   const [campaigns, setCampaigns] = useState([]);
//   const [brands, setBrands] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [selectedCampaign, setSelectedCampaign] = useState(null);

//   // Edit State
//   const [editingCampaignId, setEditingCampaignId] = useState(null);
//   const [editingCampaignTitle, setEditingCampaignTitle] = useState("");
//   const [editingCampaignBrandId, setEditingCampaignBrandId] = useState("");
//   const [savingCampaign, setSavingCampaign] = useState(false);

//   const loadCampaigns = async () => {
//     try {
//       setLoading(true);
//       setError("");

//       const data = await fetchCampaigns();

//       const campaignList = Array.isArray(data)
//         ? data
//         : Array.isArray(data?.data)
//         ? data.data
//         : [];

//       setCampaigns(campaignList);
//     } catch (err) {
//       console.error("Failed to load campaigns:", err);
//       setError("Unable to load campaigns from server.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const loadBrands = async () => {
//     try {
//       const data = await fetchBrands();
//       const brandList = Array.isArray(data)
//         ? data
//         : Array.isArray(data?.data)
//         ? data.data
//         : [];
//       setBrands(brandList);
//     } catch (err) {
//       console.error("Error fetching brands:", err);
//     }
//   };

//   useEffect(() => {
//     loadCampaigns();
//     loadBrands();
//   }, []);

//   const handleEditCampaign = (campaign) => {
//     setEditingCampaignId(campaign.id);
//     setEditingCampaignTitle(campaign.title || "");
//     setEditingCampaignBrandId(campaign.brand_id || "");
//   };

//   const handleSaveCampaign = async () => {
//     if (!editingCampaignTitle.trim()) {
//       alert("Campaign title cannot be empty.");
//       return;
//     }

//     try {
//       setSavingCampaign(true);
//       const updatedTitle = editingCampaignTitle.trim();
//       const updatedBrandId = editingCampaignBrandId;

//       // Send update to backend
//       await updateCampaign(
//         editingCampaignId,
//         updatedTitle,
//         updatedBrandId
//       );

//       // Find selected brand name for UI update
//       const matchedBrand = brands.find(
//         (b) => String(b.id) === String(updatedBrandId)
//       );
//       const updatedBrandName = matchedBrand ? matchedBrand.brand_name : "";

//       // Update UI state after successful API response
//       setCampaigns((prevCampaigns) =>
//         prevCampaigns.map((item) =>
//           item.id === editingCampaignId
//             ? {
//                 ...item,
//                 title: updatedTitle,
//                 brand_id: updatedBrandId,
//                 brand_name: updatedBrandName || item.brand_name,
//               }
//             : item
//         )
//       );

//       setEditingCampaignId(null);
//       setEditingCampaignTitle("");
//       setEditingCampaignBrandId("");
//     } catch (err) {
//       console.error("Error updating campaign:", err);
//       alert(err.message || "Failed to update campaign.");
//     } finally {
//       setSavingCampaign(false);
//     }
//   };

//   return (
//     <div className="campaign-list-container">
//       <div className="campaign-list-header">
//         <div>
//           <h2>Campaign List</h2>
//           <p>Manage and monitor active field campaigns</p>
//         </div>
//         {onCreateClick && (
//           <button className="create-btn" onClick={onCreateClick}>
//             + Create Campaign
//           </button>
//         )}
//       </div>

//       {error && <div className="alert-box error">{error}</div>}

//       {loading ? (
//         <div className="loading-state">Loading campaigns...</div>
//       ) : campaigns.length === 0 ? (
//         <div className="empty-state">No campaigns found.</div>
//       ) : (
//         <div className="campaign-table-wrapper">
//           <table className="campaign-table">
//             <thead>
//               <tr>
//                 <th>ID</th>
//                 <th>Campaign Name</th>
//                 <th>Brand</th>
//                 <th>Type</th>
//                 <th>Job Mention</th>
//                 <th>Job Added (Completed)</th>
//                 <th>Project Manager</th>
//                 <th>Reference File</th>
//                 <th>Job File</th>
//                 <th>Status</th>
//                 <th>Created At</th>
//                 <th>Action</th>
//               </tr>
//             </thead>
//             <tbody>
//               {campaigns.map((item, index) => (
//                 <tr key={item.id}>
//                   <td>{index + 1}</td>
//                   <td className="font-semibold">
//                     {editingCampaignId === item.id ? (
//                       <input
//                         type="text"
//                         value={editingCampaignTitle}
//                         onChange={(e) => setEditingCampaignTitle(e.target.value)}
//                         className="edit-input"
//                       />
//                     ) : (
//                       item.title
//                     )}
//                   </td>
//                   <td>
//                     {editingCampaignId === item.id ? (
//                       <select
//                         value={editingCampaignBrandId}
//                         onChange={(e) =>
//                           setEditingCampaignBrandId(e.target.value)
//                         }
//                         className="edit-input"
//                       >
//                         <option value="">-- Select Brand --</option>
//                         {brands.map((brand) => (
//                           <option key={brand.id} value={brand.id}>
//                             {brand.brand_name}
//                           </option>
//                         ))}
//                       </select>
//                     ) : (
//                       item.brand_name || "-"
//                     )}
//                   </td>
//                   <td>
//                     {campaignTypeNames[item.campaign_type] ||
//                       item.campaign_type ||
//                       "-"}
//                   </td>
//                   <td>{item.job_qty || 0}</td>
//                   <td>
//                     {item.assigned_job_count || 0} (
//                     {item.completed_job_count || 0}
//                     )
//                   </td>
//                   <td>{item.pm_name || item.pm_id || "-"}</td>

//                   {/* Reference File */}
//                   <td>
//                     {item.ref_file ? (
//                       <a
//                         href={item.ref_file}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                         className="file-icon-btn"
//                         title="View Reference File"
//                       >
//                         📁
//                       </a>
//                     ) : (
//                       "-"
//                     )}
//                   </td>

//                   {/* Job File */}
//                   <td>
//                     {item.job_detail_file ? (
//                       <a
//                         href={item.job_detail_file}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                         className="file-icon-btn"
//                         title="View Job File"
//                       >
//                         📁
//                       </a>
//                     ) : (
//                       "-"
//                     )}
//                   </td>

//                   {/* Status */}
//                   <td>
//                     <span
//                       className={`status-tag status-${(
//                         item.status || "DRAFT"
//                       ).toLowerCase()}`}
//                     >
//                       {item.status || "DRAFT"}
//                     </span>
//                   </td>
//                   <td>
//                     {item.created_at
//                       ? new Date(item.created_at).toLocaleDateString()
//                       : "-"}
//                   </td>
//                   <td>
//                     {editingCampaignId === item.id ? (
//                       <>
//                         <button
//                           type="button"
//                           className="save-btn"
//                           onClick={handleSaveCampaign}
//                           disabled={savingCampaign}
//                         >
//                           {savingCampaign ? "Saving..." : "Save"}
//                         </button>
//                         <button
//                           type="button"
//                           className="cancel-btn"
//                           onClick={() => {
//                             setEditingCampaignId(null);
//                             setEditingCampaignTitle("");
//                             setEditingCampaignBrandId("");
//                           }}
//                         >
//                           Cancel
//                         </button>
//                       </>
//                     ) : (
//                       <>
//                         <button
//                           type="button"
//                           className="edit-btn"
//                           onClick={() => handleEditCampaign(item)}
//                           title="Edit Campaign"
//                         >
//                           ✏️
//                         </button>
//                         <button
//                           type="button"
//                           className="campaign-view-btn"
//                           onClick={() => setSelectedCampaign(item)}
//                           title="View Campaign Details"
//                         >
//                           👁️
//                         </button>
//                       </>
//                     )}
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       )}

//       {/* Campaign Details Popup */}
//       {selectedCampaign && (
//         <div
//           className="campaign-modal-overlay"
//           onClick={() => setSelectedCampaign(null)}
//         >
//           <div
//             className="campaign-modal"
//             onClick={(e) => e.stopPropagation()}
//           >
//             <div className="campaign-modal-header">
//               <h3>Campaign Details</h3>

//               <button
//                 type="button"
//                 className="campaign-modal-close"
//                 onClick={() => setSelectedCampaign(null)}
//               >
//                 ✕
//               </button>
//             </div>

//             <div className="campaign-modal-body">
//               <table className="summary-table">
//                 <tbody>
//                   <tr>
//                     <th>Campaign Name:</th>
//                     <td>{selectedCampaign.title || "-"}</td>
//                   </tr>

//                   <tr>
//                     <th>Brand:</th>
//                     <td>
//                       {selectedCampaign.brand_name || "-"}
//                     </td>
//                   </tr>

//                   <tr>
//                     <th>Campaign Type:</th>
//                     <td>
//                       {campaignTypeNames[selectedCampaign.campaign_type] ||
//                         selectedCampaign.campaign_type ||
//                         "-"}
//                     </td>
//                   </tr>

//                   <tr>
//                     <th>Campaign Description:</th>
//                     <td>{selectedCampaign.job_description || "-"}</td>
//                   </tr>

//                   <tr>
//                     <th>Job Quantity:</th>
//                     <td>{selectedCampaign.job_qty ?? 0} Jobs</td>
//                   </tr>

//                   <tr>
//                     <th>Minimum Images:</th>
//                     <td>{selectedCampaign.min_image ?? "-"}</td>
//                   </tr>

//                   <tr>
//                     <th>Maximum Images:</th>
//                     <td>{selectedCampaign.max_image ?? "-"}</td>
//                   </tr>

//                   <tr>
//                     <th>Project Manager:</th>
//                     <td>
//                       {selectedCampaign.pm_name ||
//                         selectedCampaign.pm_id ||
//                         "Unassigned"}
//                     </td>
//                   </tr>

//                   {Number(selectedCampaign.vendor_assign) === 1 && (
//                     <tr>
//                       <th>Vendor:</th>
//                       <td>Vendor {selectedCampaign.vendor_id || "-"}</td>
//                     </tr>
//                   )}

//                   <tr>
//                     <th>Status:</th>
//                     <td>
//                       <span
//                         className={`status-tag status-${(
//                           selectedCampaign.status || "ACTIVE"
//                         ).toLowerCase()}`}
//                       >
//                         {selectedCampaign.status || "ACTIVE"}
//                       </span>
//                     </td>
//                   </tr>

//                   <tr>
//                     <th>Reference File:</th>
//                     <td>
//                       {selectedCampaign.ref_file ? (
//                         <a
//                           href={selectedCampaign.ref_file}
//                           target="_blank"
//                           rel="noopener noreferrer"
//                           className="file-icon-btn"
//                         >
//                           📁 View File
//                         </a>
//                       ) : (
//                         "None uploaded"
//                       )}
//                     </td>
//                   </tr>

//                   <tr>
//                     <th>Job Detail File:</th>
//                     <td>
//                       {selectedCampaign.job_detail_file ? (
//                         <a
//                           href={selectedCampaign.job_detail_file}
//                           target="_blank"
//                           rel="noopener noreferrer"
//                           className="file-icon-btn"
//                         >
//                           📁 View File
//                         </a>
//                       ) : (
//                         "None uploaded"
//                       )}
//                     </td>
//                   </tr>

//                   <tr>
//                     <th>Created At:</th>
//                     <td>
//                       {selectedCampaign.created_at
//                         ? new Date(
//                             selectedCampaign.created_at
//                           ).toLocaleString()
//                         : "-"}
//                     </td>
//                   </tr>

//                   <tr>
//                     <th>Updated At:</th>
//                     <td>
//                       {selectedCampaign.updated_at
//                         ? new Date(
//                             selectedCampaign.updated_at
//                           ).toLocaleString()
//                         : "-"}
//                     </td>
//                   </tr>
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default CampaignList;

import React, { useState, useEffect } from "react";
import "./CampaignList.css";
import { fetchCampaigns, updateCampaign } from "../services/campaignService";
import { fetchBrands } from "../services/brandService";

const campaignTypeNames = {
  1: "Visibility Audit",
  2: "Retail Audit",
  3: "Sampling",
};

function CampaignList({ onCreateClick }) {
  const [campaigns, setCampaigns] = useState([]);
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [selectedCampaign, setSelectedCampaign] = useState(null);

  // Edit State
  const [editingCampaignId, setEditingCampaignId] = useState(null);
  const [editingCampaignTitle, setEditingCampaignTitle] = useState("");
  const [editingCampaignBrandId, setEditingCampaignBrandId] = useState("");
  const [savingCampaign, setSavingCampaign] = useState(false);

  const loadCampaigns = async () => {
    try {
      setLoading(true);
      setError("");

      const data = await fetchCampaigns();

      const campaignList = Array.isArray(data)
        ? data
        : Array.isArray(data?.data)
        ? data.data
        : [];

      setCampaigns(campaignList);
    } catch (err) {
      console.error("Failed to load campaigns:", err);
      setError("Unable to load campaigns from server.");
    } finally {
      setLoading(false);
    }
  };

  const loadBrands = async () => {
    try {
      const data = await fetchBrands();
      const brandList = Array.isArray(data)
        ? data
        : Array.isArray(data?.data)
        ? data.data
        : [];
      setBrands(brandList);
    } catch (err) {
      console.error("Error fetching brands:", err);
    }
  };

  useEffect(() => {
    loadCampaigns();
    loadBrands();
  }, []);

  const handleEditCampaign = (campaign) => {
    setEditingCampaignId(campaign.id);
    setEditingCampaignTitle(campaign.title || "");
    setEditingCampaignBrandId(campaign.brand_id || "");
  };

  const handleViewCampaignJobs = (campaign) => {
    if (!campaign?.id) {
      console.error("Campaign ID is missing:", campaign);
      return;
    }

    window.open(
      `/job-list?campaign_id=${campaign.id}`,
    
      "noopener,noreferrer"
    );
  };

  const handleSaveCampaign = async () => {
    if (!editingCampaignTitle.trim()) {
      alert("Campaign title cannot be empty.");
      return;
    }

    try {
      setSavingCampaign(true);
      const updatedTitle = editingCampaignTitle.trim();
      const updatedBrandId = editingCampaignBrandId;

      // Send update to backend
      await updateCampaign(
        editingCampaignId,
        updatedTitle,
        updatedBrandId
      );

      // Find selected brand name for UI update
      const matchedBrand = brands.find(
        (b) => String(b.id) === String(updatedBrandId)
      );
      const updatedBrandName = matchedBrand ? matchedBrand.brand_name : "";

      // Update UI state after successful API response
      setCampaigns((prevCampaigns) =>
        prevCampaigns.map((item) =>
          item.id === editingCampaignId
            ? {
                ...item,
                title: updatedTitle,
                brand_id: updatedBrandId,
                brand_name: updatedBrandName || item.brand_name,
              }
            : item
        )
      );

      setEditingCampaignId(null);
      setEditingCampaignTitle("");
      setEditingCampaignBrandId("");
    } catch (err) {
      console.error("Error updating campaign:", err);
      alert(err.message || "Failed to update campaign.");
    } finally {
      setSavingCampaign(false);
    }
  };

  return (
    <div className="campaign-list-container">
      <div className="campaign-list-header">
        <div>
          <h2>Campaign List</h2>
          <p>Manage and monitor active field campaigns</p>
        </div>
        {onCreateClick && (
          <button className="create-btn" onClick={onCreateClick}>
            + Create Campaign
          </button>
        )}
      </div>

      {error && <div className="alert-box error">{error}</div>}

      {loading ? (
        <div className="loading-state">Loading campaigns...</div>
      ) : campaigns.length === 0 ? (
        <div className="empty-state">No campaigns found.</div>
      ) : (
        <div className="campaign-table-wrapper">
          <table className="campaign-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Campaign Name</th>
                <th>Brand</th>
                <th>Type</th>
                
                <th>Job Added (Completed)</th>
                <th>Project Manager</th>
                <th>Reference File</th>
                <th>Job File</th>
                <th>Status</th>
                <th>Created At</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {campaigns.map((item, index) => (
                <tr key={item.id}>
                  <td>{index + 1}</td>
                  <td className="font-semibold">
                    {editingCampaignId === item.id ? (
                      <input
                        type="text"
                        value={editingCampaignTitle}
                        onChange={(e) => setEditingCampaignTitle(e.target.value)}
                        className="edit-input"
                      />
                    ) : (
                      item.title
                    )}
                  </td>
                  <td>
                    {editingCampaignId === item.id ? (
                      <select
                        value={editingCampaignBrandId}
                        onChange={(e) =>
                          setEditingCampaignBrandId(e.target.value)
                        }
                        className="edit-input"
                      >
                        <option value="">-- Select Brand --</option>
                        {brands.map((brand) => (
                          <option key={brand.id} value={brand.id}>
                            {brand.brand_name}
                          </option>
                        ))}
                      </select>
                    ) : (
                      item.brand_name || "-"
                    )}
                  </td>
                  <td>
  {campaignTypeNames[item.campaign_type] ||
    item.campaign_type ||
    "-"}
</td>

<td>
  <button
    type="button"
    className="campaign-job-count"
    onClick={() => handleViewCampaignJobs(item)}
    title="View jobs for this campaign"
  >
    {item.assigned_job_count || 0} (
    {item.completed_job_count || 0}
    )
  </button>
</td>
                  <td>{item.pm_name || item.pm_id || "-"}</td>

                  {/* Reference File */}
                  <td>
                    {item.ref_file ? (
                      <a
                        href={item.ref_file}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="file-icon-btn"
                        title="View Reference File"
                      >
                        📁
                      </a>
                    ) : (
                      "-"
                    )}
                  </td>

                  {/* Job File */}
                  <td>
                    {item.job_detail_file ? (
                      <a
                        href={item.job_detail_file}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="file-icon-btn"
                        title="View Job File"
                      >
                        📁
                      </a>
                    ) : (
                      "-"
                    )}
                  </td>

                  {/* Status */}
                  <td>
                    <span
                      className={`status-tag status-${(
                        item.status || "DRAFT"
                      ).toLowerCase()}`}
                    >
                      {item.status || "DRAFT"}
                    </span>
                  </td>
                  <td>
                    {item.created_at
                      ? new Date(item.created_at).toLocaleDateString()
                      : "-"}
                  </td>
                  <td>
                    {editingCampaignId === item.id ? (
                      <>
                        <button
                          type="button"
                          className="save-btn"
                          onClick={handleSaveCampaign}
                          disabled={savingCampaign}
                        >
                          {savingCampaign ? "Saving..." : "Save"}
                        </button>
                        <button
                          type="button"
                          className="cancel-btn"
                          onClick={() => {
                            setEditingCampaignId(null);
                            setEditingCampaignTitle("");
                            setEditingCampaignBrandId("");
                          }}
                        >
                          Cancel
                        </button>
                      </>
                    ) : (
                      <>
                        <button
                          type="button"
                          className="edit-btn"
                          onClick={() => handleEditCampaign(item)}
                          title="Edit Campaign"
                        >
                          ✏️
                        </button>
                        <button
                          type="button"
                          className="campaign-view-btn"
                          onClick={() => setSelectedCampaign(item)}
                          title="View Campaign Details"
                        >
                          👁️
                        </button>
                      </>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Campaign Details Popup */}
      {selectedCampaign && (
        <div
          className="campaign-modal-overlay"
          onClick={() => setSelectedCampaign(null)}
        >
          <div
            className="campaign-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="campaign-modal-header">
              <h3>Campaign Details</h3>

              <button
                type="button"
                className="campaign-modal-close"
                onClick={() => setSelectedCampaign(null)}
              >
                ✕
              </button>
            </div>

            <div className="campaign-modal-body">
              <table className="summary-table">
                <tbody>
                  <tr>
                    <th>Campaign Name:</th>
                    <td>{selectedCampaign.title || "-"}</td>
                  </tr>

                  <tr>
                    <th>Brand:</th>
                    <td>
                      {selectedCampaign.brand_name || "-"}
                    </td>
                  </tr>

                  <tr>
                    <th>Campaign Type:</th>
                    <td>
                      {campaignTypeNames[selectedCampaign.campaign_type] ||
                        selectedCampaign.campaign_type ||
                        "-"}
                    </td>
                  </tr>

                  <tr>
                    <th>Campaign Description:</th>
                    <td>{selectedCampaign.job_description || "-"}</td>
                  </tr>

                  <tr>
                    <th>Job Quantity:</th>
                    <td>{selectedCampaign.job_qty ?? 0} Jobs</td>
                  </tr>

                  <tr>
                    <th>Minimum Images:</th>
                    <td>{selectedCampaign.min_image ?? "-"}</td>
                  </tr>

                  <tr>
                    <th>Maximum Images:</th>
                    <td>{selectedCampaign.max_image ?? "-"}</td>
                  </tr>

                  <tr>
                    <th>Project Manager:</th>
                    <td>
                      {selectedCampaign.pm_name ||
                        selectedCampaign.pm_id ||
                        "Unassigned"}
                    </td>
                  </tr>

                  {Number(selectedCampaign.vendor_assign) === 1 && (
                    <tr>
                      <th>Vendor:</th>
                      <td>Vendor {selectedCampaign.vendor_id || "-"}</td>
                    </tr>
                  )}

                  <tr>
                    <th>Status:</th>
                    <td>
                      <span
                        className={`status-tag status-${(
                          selectedCampaign.status || "ACTIVE"
                        ).toLowerCase()}`}
                      >
                        {selectedCampaign.status || "ACTIVE"}
                      </span>
                    </td>
                  </tr>

                  <tr>
                    <th>Reference File:</th>
                    <td>
                      {selectedCampaign.ref_file ? (
                        <a
                          href={selectedCampaign.ref_file}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="file-icon-btn"
                        >
                          📁 View File
                        </a>
                      ) : (
                        "None uploaded"
                      )}
                    </td>
                  </tr>

                  <tr>
                    <th>Job Detail File:</th>
                    <td>
                      {selectedCampaign.job_detail_file ? (
                        <a
                          href={selectedCampaign.job_detail_file}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="file-icon-btn"
                        >
                          📁 View File
                        </a>
                      ) : (
                        "None uploaded"
                      )}
                    </td>
                  </tr>

                  <tr>
                    <th>Created At:</th>
                    <td>
                      {selectedCampaign.created_at
                        ? new Date(
                            selectedCampaign.created_at
                          ).toLocaleString()
                        : "-"}
                    </td>
                  </tr>

                  <tr>
                    <th>Updated At:</th>
                    <td>
                      {selectedCampaign.updated_at
                        ? new Date(
                            selectedCampaign.updated_at
                          ).toLocaleString()
                        : "-"}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default CampaignList;